import { LivanceApiErrorTypes } from "@repo/lib/src/enums";
import { LivanceTypedError } from "@/lib/livance-typed-error.tsx";

export const isRepeatedPatientError = (error: Error): boolean => {
  return (
    error instanceof LivanceTypedError &&
    error.typeName === LivanceApiErrorTypes.RepeatedPatientError.valueOf()
  );
};
